import React from "react";
import { Grid, Card, CardContent } from "@mui/material";
import GenericAlert from "../GenericAlert";
import AccountProfileForm from "./AccountProfileForm";
import SaveChangesAccount from "./SaveChangesAccount";
import { IAccountContent } from "../../interfaces/account";
import GenericForm from "../GenericForm";
import { IUserResponses } from "../../interfaces/userContext";

const AccountContent = ({
  alert,
  values,
  disableInputs,
  disableSubmit,
  errors,
  handleChange,
  handleCancel,
  handleSubmit,
  isMobile,
}: IAccountContent) => (
  <>
    <Grid item xs={12} md={7}>
      {alert.showAlert && <GenericAlert alert={alert} />}
    </Grid>
    <Grid item xs={12} md={7} className="m-t-20">
      {isMobile ? (
        <GenericForm onSubmit={handleSubmit} disableSubmit={disableSubmit}>
          <AccountProfileForm
            errors={errors}
            handleChange={handleChange}
            currentUser={values as IUserResponses}
            disableInputs={disableInputs}
          />
        </GenericForm>
      ) : (
        <Card
          className="br-20 bg-light"
          sx={{ padding: 3, paddingBottom: 5.75 }}
        >
          <CardContent>
            <GenericForm onSubmit={handleSubmit} disableSubmit={disableSubmit}>
              <AccountProfileForm
                errors={errors}
                handleChange={handleChange}
                currentUser={values as IUserResponses}
                disableInputs={disableInputs}
              />
            </GenericForm>
          </CardContent>
        </Card>
      )}
    </Grid>
    {!disableInputs && (
      <Grid item xs={12} md={7}>
        <SaveChangesAccount
          disableSubmit={disableSubmit}
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
        />
      </Grid>
    )}
  </>
);

export default AccountContent;
